import {
  IConversationInputModel,
  IAddParticipantConversationInputModel,
  IConversationForSolicitationInputModel,
} from 'inputModels';
import { IConversationViewModel } from 'viewModels';
import { IMessageAssistantModel } from 'entities';

import api from '../services/api/axios';

const createConversation = (conversation: IConversationInputModel) => {
  return new Promise<string>((resolve, reject) => {
    api
      .post(`/conversation`, conversation)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};
const sendMessage = (message: FormData) => {
  return new Promise((resolve, reject) => {
    api
      .post(`/conversation/send-message`, message, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

// const sendAssistantMessage = (message: FormData) => {
//   return new Promise((resolve, reject) => {
//     api
//       .post(`/conversation/send-assistant-message`, message, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       })
//       .then(({ data }) => resolve(data))
//       .catch(reject);
//   });
// };
const sendAssistantMessage = (message: IMessageAssistantModel) => {
  return new Promise<IMessageAssistantModel>((resolve, reject) => {
    api
      .post(`/conversation/send-assistant-message`, message)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const get = (id: string) => {
  return new Promise<IConversationViewModel>((resolve, reject) => {
    api
      .get(`/conversation/get-by/${id}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};
const getAll = (uid: string) => {
  return new Promise<IConversationViewModel[]>((resolve, reject) => {
    api
      .get(`/conversation/get-all/${uid}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};
const readMessages = (id: string) => {
  return new Promise((resolve, reject) => {
    api
      .put(`/conversation/read-messages/${id}`)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const addParticipants = (input: IAddParticipantConversationInputModel) => {
  return new Promise((resolve, reject) => {
    api
      .post(`/conversation/add-participants`, input)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const createConversationForSolicitation = (input: IConversationForSolicitationInputModel) => {
  return new Promise<string>((resolve, reject) => {
    api
      .post(`/conversation/create-for-solicitation`, input)
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
};

const ConversationController = {
  createConversation,
  sendMessage,
  sendAssistantMessage,
  get,
  getAll,
  readMessages,
  addParticipants,
  createConversationForSolicitation,
};
export default ConversationController;
